// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2a4qp","modalFooterButton":"ModalNotes_modalFooterButton__2_mEp"};